import BaseService from '@src/services/BaseService'

class WorkLeaveService extends BaseService {
    constructor() {
        super('work-leaves')
    }
}
export default new WorkLeaveService()
